export default __webpack_public_path__ + "static/media/notification.6dc40117.mp3";